
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M20.5.5h-17a1 1 0 00-1 1v20a1 1 0 001 1h17a1 1 0 001-1v-20a1 1 0 00-1-1zm-18 4h19","stroke":"#50657c","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M12 17a3.5 3.5 0 100-7 3.5 3.5 0 000 7zM4.5 2.5h4m-5 20v1m17-1v1","stroke":"#50657c","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M12 19.5a6 6 0 100-12 6 6 0 000 12zm7.25-17.25a.25.25 0 110 .5.25.25 0 010-.5zm-2.5 0a.25.25 0 110 .5.25.25 0 010-.5zm-2.5 0a.25.25 0 110 .5.25.25 0 010-.5z","stroke":"#50657c","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    